export function getSubscriptionHavingProductFromSubscriptions(subscriptions, productSKU) {
  const subscriptionForProduct = subscriptions.find((subscription) => {
    return subscription.sku == productSKU;
  });
  if (!subscriptionForProduct) {
    return null;
  }
  return subscriptionForProduct;
}
